import { createContext, useContext } from 'react';

interface EmbeddedContextType {
  isEmbedded: boolean;
}

/**
 * React context for sharing embedded mode state across the component tree.
 * When isEmbedded is true, components should hide non-essential UI and
 * disable user-configurable selectors (locked to URL param values).
 */
const EmbeddedContext = createContext<EmbeddedContextType>({ isEmbedded: false });

const useEmbedded = (): EmbeddedContextType => useContext(EmbeddedContext);

export { EmbeddedContext, useEmbedded };
